import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { getCMTPLCascoInsuranceList } from '../../redux/modules/insurances';
import InsurancesTable from './InsurancesTable';
import { INSURANCE_TYPES } from '../../constants';
import { cmtplCascoColumns } from './utils';

const CMTPLCascoInsurancesTable = () => {
  const { tblData, isLoading } = useSelector((
    store,
  ) => store.insurances.cmtplCascoInsuranceList, shallowEqual);

  return (
    <InsurancesTable
      type={INSURANCE_TYPES.CMTPL_CASCO}
      title="insuranceList.cmtplCasco"
      columns={cmtplCascoColumns}
      tblData={tblData}
      isLoading={isLoading}
      getInsuranceList={getCMTPLCascoInsuranceList}
    />
  );
};

export default CMTPLCascoInsurancesTable;
